import { isNightOffMeal } from './nightOff.js'

const ASKED_KEY = 'agent_plan_freshness_asked_v1'

const DAY_SENTENCE = {
  MON: 'Monday',
  TUE: 'Tuesday',
  WED: 'Wednesday',
  THU: 'Thursday',
  FRI: 'Friday',
  SAT: 'Saturday',
  SUN: 'Sunday',
}

export function planFreshnessDay(dayKey) {
  return DAY_SENTENCE[dayKey] || ''
}

export function planFreshnessPrompt(dayLabel, itemName, daysAgo) {
  const day = String(dayLabel || '').trim()
  const food = String(itemName || '').trim().toLowerCase()
  if (!day || !food) return ''
  const when = Number(daysAgo) >= 7 ? 'from last week' : 'from a few days ago'
  return `${day} uses ${food} ${when}. Still have it?`
}

function readAsked() {
  try {
    const raw = window.localStorage.getItem(ASKED_KEY)
    const parsed = raw ? JSON.parse(raw) : {}
    return parsed && typeof parsed === 'object' ? parsed : {}
  } catch {
    return {}
  }
}

export function freshnessAskKey(planItemId, recipeId) {
  return `${planItemId}:${recipeId}`
}

export function hasAnsweredFreshness(planItemId, recipeId) {
  if (!planItemId || !recipeId) return false
  return Boolean(readAsked()[freshnessAskKey(planItemId, recipeId)])
}

export function rememberFreshnessAnswer(planItemId, recipeId) {
  if (!planItemId || !recipeId) return
  const next = readAsked()
  next[freshnessAskKey(planItemId, recipeId)] = 1
  try {
    window.localStorage.setItem(ASKED_KEY, JSON.stringify(next))
  } catch {
    /* the dinner still settles in this view */
  }
}

export function shouldAskPlanFreshness(meal) {
  const item = meal?.agingItem
  if (!item?.id || !String(item.name || '').trim()) return false
  if (!meal.planItemId || !meal.recipeId) return false
  if (meal.isPast || meal.status !== 'planned') return false
  if (isNightOffMeal(meal)) return false
  if (hasAnsweredFreshness(meal.planItemId, meal.recipeId)) return false
  return true
}
